import { Link } from "react-router-dom";
import { ArrowLeft, Download } from "lucide-react";
import { Seo } from "../components/Seo";
import { AdminGate } from "../components/admin/AdminGate";
import { useAdminSession } from "../hooks/useAdminLeads";

const FILES = [
  { file: "lake-monitor-ai-logo-dark-text.png", label: "Logo — dark text (PNG, transparent)", use: "Light backgrounds: letterhead, invoices, press releases, Word/Google Docs", bg: "bg-white" },
  { file: "lake-monitor-ai-logo-white-text.png", label: "Logo — white text (PNG, transparent)", use: "Dark backgrounds: presentations, video, dark social headers", bg: "bg-[#0A0F1D]" },
  { file: "lake-monitor-ai-logo-white-text-on-navy.png", label: "Logo — on navy (PNG)", use: "When transparency isn't supported (e.g. some directories)", bg: "bg-[#0A0F1D]" },
  { file: "lake-monitor-ai-mark.png", label: "Mark only (PNG, 672×672)", use: "Social avatars, favicons, app icons, watermark", bg: "bg-white", square: true },
  { file: "lake-monitor-ai-logo.svg", label: "Logo (SVG, vector)", use: "Print at any size; designers and sign shops", bg: "bg-white" },
];

const Asset = ({ a }) => (
  <div className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden" data-testid={`brand-asset-${a.file}`}>
    <div className={`${a.bg} flex items-center justify-center p-8 h-44 border-b border-slate-200`}>
      <img src={`/brand/${a.file}`} alt={a.label} className={a.square ? "h-24 w-24" : "max-h-24 w-auto"} />
    </div>
    <div className="p-5">
      <div className="font-semibold text-slate-900">{a.label}</div>
      <p className="mt-1 text-sm text-slate-600">{a.use}</p>
      <a href={`/brand/${a.file}`} download data-testid={`brand-download-${a.file}`} className="mt-4 inline-flex items-center gap-2 rounded-lg bg-cyan-600 hover:bg-cyan-700 text-white text-sm font-semibold px-4 py-2 transition-colors">
        <Download className="w-4 h-4" /> Download
      </a>
    </div>
  </div>
);

export default function BrandAssets() {
  const { authed, login } = useAdminSession();
  return (
    <AdminGate page="adminBrand" authed={authed} login={login}>
      <div className="min-h-screen pt-28 pb-20 px-4 sm:px-6 lg:px-8">
        <Seo page="adminBrand" />
        <div className="max-w-5xl mx-auto" data-testid="brand-assets-page">
          <Link to="/admin" data-testid="brand-back-link" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-cyan-700">
            <ArrowLeft className="w-4 h-4" /> Back to leads
          </Link>
          <h1 className="mt-4 text-3xl font-extrabold text-slate-900 tracking-tight">Brand assets</h1>
          <p className="mt-2 text-base text-slate-600">The header logo as ready-to-use files. Colors: cyan #22D3EE → teal #14B8A6 gradient, navy #0A0F1D, text #0F172A. Fonts: Outfit (wordmark), JetBrains Mono (tagline).</p>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
            {FILES.map((a) => <Asset key={a.file} a={a} />)}
          </div>
        </div>
      </div>
    </AdminGate>
  );
}
